module.exports = __webpack_public_path__ + "img/47bcfab7517005bd89c265c59abb953f.png";